module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a atividade?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirAtividade()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }, [_vm._v("\n    A atividade \"" + _vm._s(this.descricaoAtividadeExclusao) + "\" será excluída após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaAtividades,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui atividades.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoEditarAtividade(_vm.idProjeto, props.item.id)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1 && _vm.projeto.situacao.item === 15) || (_vm.projeto.assessor === true && _vm.projeto.situacao.item === 15)) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoExcluirAtividade(props.item.id, props.item.descricao)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]
      }
    }, {
      key: "item.nomeDescricao",
      fn: function(props) {
        return [(props.item.detalhamento !== null && props.item.detalhamento !== '') ? _c('div', [_vm._v(_vm._s(props.item.descricao)), _c('br'), _c('br'), _vm._v(_vm._s(props.item.detalhamento))]) : _c('div', [_vm._v(_vm._s(props.item.descricao))])]
      }
    }, {
      key: "item.dtInicioPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioPrevisto)))]
      }
    }, {
      key: "item.dtFimPrevisto",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimPrevisto)))]
      }
    }, {
      key: "item.dtInicioEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtInicioEfetivo)))]
      }
    }, {
      key: "item.dtFimEfetivo",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dtFimEfetivo)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaAtividades.length) + " atividades\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "VinculosProjeto",
      "editar": "NovaAtividade",
      "nome_editar": "Nova Atividade",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d399c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-atividades-tabela.vue
// module id = 483
// module chunks = 0